<nz-modal
  [(nzVisible)]="visible"
  [nzTitle]="isTitleText ? titleTextRef : titleTemplateRef"
  [nzFooter]="footer"
  [nzWidth]="width"
  [nzDraggable]="draggable"
  [nzClosable]="closable"
  [nzCentered]="centered"
  [nzMask]="mask"
  [nzMaskClosable]="maskClosable"
  [nzKeyboard]="escToClose"
  (nzAfterClose)="onAfterClose()"
  (nzOnCancel)="onClose()"
>
  <nz-spin
    *nzModalContent
    class="ui-modal-spining"
    [style.height]="height"
    [nzSpinning]="loading"
    [nzIndicator]="indicatorTemplate"
  >
    <ng-content></ng-content>
  </nz-spin>
</nz-modal>

<ng-template #titleTextRef>
  <div class="ui-modal-title" [ngStyle]="{ textAlign: titleAlign }">
    <span class="ui-modal-title-text">{{ title | localization }}</span>
    <span *ngIf="description" class="ui-modal-title-description">{{
      description | localization
    }}</span>
  </div>
</ng-template>

<ng-template #indicatorTemplate>
  <span class="loading-spin-icon" nz-icon nzType="loading"></span>
  <span class="loading-spin-text">{{ 'Загрузка' | localization }}</span>
</ng-template>
